// extracted by mini-css-extract-plugin
export default {"Success":"Message_Success__+-tIN","Error":"Message_Error__gM4pC","Info":"Message_Info__V-mgf","Warning":"Message_Warning__+NLRm"};